<template>
  <div v-frag>
    <div
      v-frag
      v-if="
        inputProp.type == 'text' ||
          inputProp.type == 'number' ||
          inputProp.type == 'email' ||
          inputProp.type == 'password' ||
          inputProp.type == 'DNI'
      "
    >
      <v-input
        :prepend-icon="inputProp.icon"
        dense
        :rules="inputProp.rules"
        hide-details
        v-model="inputProp.value"
      >
        <!-- <v-input dense> -->
        <div class="mt-1">{{ inputProp.text }}</div>
      </v-input>
      <!-- <v-text-field
            solo
            label="Prepend"
            :placeholder="inputProp.placeholder"
            clearable
            flat
            class="rounded-lg"
            :readonly="inputProp.readonly"
            :required="inputProp.required"
            :disabled="inputProp.disabled"
            :counter="inputProp.counter"
            :type="inputProp.type"
            v-mask="inputProp.mask"
            v-model="inputProp.value"
            :rules="inputProp.rules"
            :min="inputProp.min"
            height="50"
      ></v-text-field> -->
      <v-text-field
        :placeholder="inputProp.placeholder"
        background-color="white"
        solo
        height="50"
        flat
        dense
        :clearable="!inputProp.readonly"
        class="rounded-lg"
        :readonly="inputProp.readonly"
        :required="inputProp.required"
        :disabled="inputProp.disabled"
        :counter="inputProp.counter"
        :type="inputProp.type"
        v-mask="inputProp.mask"
        v-model="inputProp.value"
        :rules="inputProp.rules"
        :min="inputProp.min"
      ></v-text-field>
    </div>

    <div v-frag v-if="inputProp.type == 'radio'">
      <v-input
        :prepend-icon="inputProp.icon"
        dense
        :rules="inputProp.rules"
        hide-details
        v-model="inputProp.value"
      >
        <div v-frag class="mt-1">{{ inputProp.text }}</div>
      </v-input>
      <v-radio-group v-model="inputProp.value">
        <v-row>
          <v-col
            v-for="(itemOptions, indexOptions) in inputProp.data"
            :key="indexOptions"
            :cols="inputProp.config.cols"
            :xs="inputProp.config.xs"
            :sm="inputProp.config.sm"
            :md="inputProp.config.md"
            :lg="inputProp.config.lg"
            :xl="inputProp.config.xl"
          >
            <v-radio
              :label="itemOptions.text"
              :value="itemOptions.value"
            ></v-radio>
          </v-col>
        </v-row>
      </v-radio-group>
    </div>

    <div v-frag v-if="inputProp.type == 'checkbox'">
      <!-- <v-input :prepend-icon="inputProp.icon" dense style="padding-bottom:-10px"> -->
      <div v-frag class="mt-1">
        <v-icon>{{ inputProp.icon }}</v-icon> {{ inputProp.text }}
      </div>
      <!-- </v-input> -->
      <v-row>
        <div v-frag v-if="inputProp.multiple">
          <v-col
            v-for="(itemOptions, indexOptions) in inputProp.data"
            :key="indexOptions"
            :cols="inputProp.config.cols"
            :xs="inputProp.config.xs"
            :sm="inputProp.config.sm"
            :md="inputProp.config.md"
            :lg="inputProp.config.lg"
            :xl="inputProp.config.xl"
          >
            <v-checkbox
              v-model="inputProp.value"
              :label="itemOptions.text"
              :value="itemOptions.value"
              :rules="itemOptions.rules"
            ></v-checkbox>
          </v-col>
        </div>
        <div v-frag v-else>
          <v-col
            :cols="inputProp.config.cols"
            :xs="inputProp.config.xs"
            :sm="inputProp.config.sm"
            :md="inputProp.config.md"
            :lg="inputProp.config.lg"
            :xl="inputProp.config.xl"
          >
            <v-checkbox
              dense
              v-model="inputProp.value"
              :label="inputProp.data[0].text"
              :value="inputProp.data[0].value"
              :rules="inputProp.rules"
            ></v-checkbox>
          </v-col>
        </div>
      </v-row>
    </div>

    <div v-frag v-if="inputProp.type == 'select'">
      <v-input
        :prepend-icon="inputProp.icon"
        dense
        :rules="inputProp.rules"
        hide-details
        v-model="inputProp.value"
      >
        <div v-frag class="mt-1">{{ inputProp.text }}</div>
      </v-input>
      <v-select
        v-model="inputProp.value"
        :items="inputProp.data"
        :rules="inputProp.rules"
        :label="inputProp.placeholder"
        :readonly="inputProp.readonly"
        :required="inputProp.required"
        :disabled="inputProp.disabled"
        solo
        flat
        :clearable="!inputProp.readonly"
        @change="changed()"
      ></v-select>
    </div>

    <div v-frag v-if="inputProp.type == 'autocomplete'">
      <v-input :prepend-icon="inputProp.icon" dense>
        <div v-frag class="mt-1">{{ inputProp.text }}</div>
      </v-input>
      <v-autocomplete
        v-model="inputProp.value"
        :items="inputProp.data"
        :rules="inputProp.rules"
        :label="inputProp.placeholder"
        :readonly="inputProp.readonly"
        :required="inputProp.required"
        :disabled="inputProp.disabled"
        solo
        flat
        clearable
        @change="changed()"
      ></v-autocomplete>
    </div>

    <div v-frag v-if="inputProp.type == 'date'">
      <v-input
        :prepend-icon="inputProp.icon"
        dense
        :rules="inputProp.rules"
        hide-details
        v-model="inputProp.value"
      >
        <div v-frag class="mt-1">{{ inputProp.text }}</div>
      </v-input>
      <v-menu
        ref="menu1"
        v-model="inputProp.config.view"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :placeholder="inputProp.placeholder"
            background-color="white"
            solo
            height="50"
            flat
            dense
            clearable
            class="rounded-lg"
            :readonly="inputProp.readonly"
            :required="inputProp.required"
            :counter="inputProp.counter"
            :type="inputProp.type"
            v-mask="inputProp.mask"
            v-model="inputProp.value"
            :rules="inputProp.rules"
            v-bind="attrs"
            @blur="date = parseDate(inputProp.value)"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="inputProp.value"
          locale="es-AR" 
          year-icon="mdi-chevron-down"
          @input="inputProp.config.view = false"
        ></v-date-picker>
      </v-menu>
    </div>
    <div v-frag style="display:none">{{ debug }}</div>
  </div>
</template>
<script>
import Faker from "faker";
export default {
  name: "InputCustom",
  props: ["inputProp"],
  mounted() {},
  computed: {
    debug() {
      let temp = this.inputProp;
      let that = this;
      if (this.$store.getters.debug == 1) {
        let valor = "";
        if (temp.type == "email") {
          valor = Faker.internet.email();
        }
        if (temp.type == "number") {
          // valor = parseInt(Math.random() * (maskCantidad - 0) + 0)
          valor = Faker.random.number();
        }
        if (temp.type == "DNI") {
          valor = Faker.random.number();
        }

        if (temp.type == "text") {
          valor = Faker.random.words();
        }
        if (temp.type == "password") {
          valor = Faker.random.number();
        }

        if (temp.type == "date") {
          valor = new Date().toISOString().substr(0, 10);
        }

        if (temp.type == "select") {
          let limit = temp.data.length;
          let datos = temp.data;
          if (limit > 0) {
            let opciones = [];
            for (let indexTemp in datos) {
              opciones.push(datos[indexTemp].value);
            }

            let limit2 = opciones.length;

            valor = opciones[parseInt(Math.random() * (limit2 - 0) + 0)];
          }
        }

        // if (temp.type == "checkbox" && temp.multiple) {
        //   let limit = temp.data.length;
        //   let datos = temp.data;
        //   if (limit > 0) {
        //     let opciones = []
        //     for(let indexTemp in datos){
        //       opciones.push(datos[indexTemp].value)
        //     }

        //     let limit2 = opciones.length

        //     valor = opciones[parseInt(Math.random() * (limit2 - 0) + 0)];
        //   }
        // }

        if (temp.value == "" && temp.required) {
          temp.value = valor;
        }
        that.inputs = temp;
      }
      return this.$store.getters.debug;
    }
  },
  data: () => ({}),
  methods: {
    changed() {
      this.$emit("change", this.inputProp);
    }, 
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
  }
};
</script>
